module.exports = __webpack_public_path__ + "static/img/anisha_pizza.383fa53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/anisha_pizza.jpg
// module id = HrnQ
// module chunks = 0